export default __webpack_public_path__ + "static/media/logo.c4d8e28e.png";